/**
 * ViewportCameraProvider
 * Configuration des caméras par mode de vue.
 * Modifiez les positions/zoom ici pour ajuster l'angle initial de chaque mode.
 */

import {
    MainCamera,
    FrontCamera,
    TopCamera,
    BottomCamera,
    ComparativeCamera,
} from 'Domain/Scene/Provider/CameraProvider';

const cameraByName = {
    main: MainCamera,
    front: FrontCamera,
    top: TopCamera,
    bottom: BottomCamera,
    comparative: ComparativeCamera,
};

export const ViewportCameraConfig = {
    single: {
        main: { x: 0, y: -180, z: 0, zoom: 1, upX: 0, upY: 0, upZ: 1 },
    },
    double: {
        bottom: { x: 0, y: 0, z: -300, zoom: 1, upX: 0, upY: -1, upZ: 0 },
        top:    { x: 0, y: 0, z: 300,  zoom: 1, upX: 0, upY: 1, upZ: 0 },
    },
    triple: {
        bottom: { x: 0, y: 0, z: -300, zoom: 0.7, upX: 0, upY: -1, upZ: 0 },
        front:  { x: 0, y: -300, z: 0, zoom: 0.7, upX: 0, upY: 0, upZ: 1 },
        top:    { x: 0, y: 0, z: 300,  zoom: 0.7, upX: 0, upY: 1, upZ: 0 },
    },
    comparative: {
        main:       { x: 0, y: -180, z: 0, zoom: 0.65, upX: 0, upY: 0, upZ: 1 },
        comparative:{ x: 0, y: -180, z: 0, zoom: 0.65, upX: 0, upY: 0, upZ: 1 },
    },
};

/**
 * Retourne la configuration caméra pour un mode donné.
 * @param {string} mode — 'single' | 'double' | 'triple' | 'comparative'
 */
export const getCameraConfigForMode = (mode) => {
    return ViewportCameraConfig[mode] || ViewportCameraConfig.single;
};

/**
 * Réinitialise la position et le zoom de toutes les caméras
 * utilisées par le mode de vue sélectionné.
 * @param {string} mode
 */
export const resetViewportCamera = (mode) => {
    const cfg = getCameraConfigForMode(mode);

    Object.entries(cfg).forEach(([camName, values]) => {
        const cam = cameraByName[camName];
        if (!cam) return;

        cam.position.set(values.x, values.y, values.z);
        if (values.upX !== undefined && values.upY !== undefined && values.upZ !== undefined) {
            cam.up.set(values.upX, values.upY, values.upZ);
        }

        if (cam.userData && cam.userData.target) {
            cam.userData.target = null;
        }

        if (values.zoom !== undefined) {
            cam.zoom = values.zoom;
            cam.updateProjectionMatrix();
        }
    });
};
